import { useState, useEffect } from 'react'
import api from '../../services/api'
import { useAuthStore } from '../../store/authStore'
import MentorPortal from './MentorPortal'
import LoadingSpinner from '../../components/LoadingSpinner'

/**
 * MentorExperienceGateway
 *
 * Routing boundary for Project Lab industry mentors. Mounted for every
 * /mentor/* path. Establishes mentor identity from GET /project-lab/mentor/context
 * (fail-closed: only renders the portal on an explicit active-mentor response).
 */
export default function MentorExperienceGateway() {
  const logout = useAuthStore((s) => s.logout)
  const [context, setContext] = useState(null)
  const [status, setStatus] = useState('loading') // loading | ready | error

  useEffect(() => {
    let cancelled = false
    api.get('/project-lab/mentor/context')
      .then((res) => {
        if (cancelled) return
        setContext(res.data)
        setStatus('ready')
      })
      .catch((err) => {
        if (cancelled) return
        console.error('[MentorGateway] context failed:', err.response?.status, err.response?.data || err.message)
        setStatus('error')
      })
    return () => { cancelled = true }
  }, [])

  if (status === 'loading') {
    return (
      <div className="min-h-screen cinema-page flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (status === 'error' || !context?.mentor) {
    return (
      <div className="min-h-screen cinema-page flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-4">
          <p className="text-[10px] uppercase tracking-[0.2em] text-cinema-gold">Project Lab</p>
          <h1 className="font-display text-xl text-white">Mentor access unavailable</h1>
          <p className="text-sm text-cinema-muted">
            This account does not have an active Project Lab mentor profile, or your
            invitation setup has not been completed.
          </p>
          <button
            onClick={logout}
            className="px-4 py-2 border border-white/10 text-xs uppercase tracking-wider text-cinema-soft hover:text-white hover:border-cinema-gold/40 transition-colors rounded-none"
          >
            Sign out
          </button>
        </div>
      </div>
    )
  }

  return <MentorPortal context={context} />
}
